import moment from 'moment'
import { CALENDAR_VIEW_MODES } from '@/constants/CalendarConsts'

//Private functions
const addDays = (date, days) => {
  var date = new Date(date.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

//Public functions
export const getArrayOfDays = (startDate, stopDate) => {
  var dateArray = new Array();
  var currentDate = startDate;
  while (currentDate <= stopDate) {
      dateArray.push(new Date (currentDate));
      currentDate = addDays(currentDate, 1);
  }

  return dateArray;
}

export const generateStartEndDates = (date, previewMode) => {
  let endDate
  let startDate

  if(previewMode == CALENDAR_VIEW_MODES.WEEK) {
      startDate = date
      endDate = moment(startDate).add(6, 'days').toDate()
  } else {
      startDate = moment(date).subtract(moment(date).day(), 'days').toDate()
      endDate = moment(date).endOf('month').toDate()

      if(moment(endDate).day() != 6) {
        endDate = moment(endDate).add(6 - moment(endDate).day(), 'days').toDate()
      }
  }

  return {
    startDate,
    endDate
  }
}
